// This file is used for setting up the Global Context
// In the future, we may need to reorganize this directory
// to account for specialized (component specific) Context
// providers, but for now, this only pertains to the Global state

import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';

import Reducer, { initialState } from '@context/reducer';

export const GlobalAppContext = createContext();

const GlobalContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);

  return (
    <GlobalAppContext.Provider value={{ state, dispatch }}>
      {children}
    </GlobalAppContext.Provider>
  );
};

GlobalContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default GlobalContextProvider;
